import { useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three-stdlib';

type Props = { url: string };

export const ModelPreloader = ({ url }: Props) => {
  useLoader(GLTFLoader, [url]);
  return null;
};

export default ModelPreloader;
